






// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBaseFamily from '@/components/administration/family/edit/EditBaseFamily.vue'
import * as rules from '@/utils/validationRules'
import { toStringDictionary } from '@/utils/groupBy'
import { getDefaultAloFamily } from '@/models/alo/AloFamily'
import { AloFamily } from '@/models/alo/AloFamily'
import AddressEdit from '@/components/administration/address/AddressEdit.vue' 

@Component({
  name: 'EditAdresse',     
  components:{EditBaseFamily,AddressEdit}
})
export default class EditAdresse extends Vue {
      
  private family:AloFamily = getDefaultAloFamily()

  edit(item:AloFamily) {    
    this.family = (this.$refs.baseEdit as EditBaseFamily).edit(item)    
  }

 
  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }  
      
}
